import { Box } from "@mui/material";
import { ReactComponent as DeadlinePlan } from "assets/DeadlinePlan.svg";
import { ReactComponent as InitiativePlan } from "assets/InitiativePlan.svg";
import { ReactComponent as RecommendedPlan } from "assets/Recommended.svg";
import { useEffect, useState } from "react";
import { tokens } from "styles/Tokens";
import { brandDeadlinesType } from "utils/CommonConstants";
import { getUIFormatDate } from "utils/DateHelper";
import "./Plantype.scss";
import Typography from "./Typography";

interface Props {
  planType: number;
  initiativeName?: string;
  brandDeadlineDate?: string;
}

function PlanType(props: Props) {
  const { planType, initiativeName, brandDeadlineDate } = props;
  const [planTypeDetail, setPlanTypeDetail] = useState<any>();

  const getPlanTypeDetails = (planType: number) => {
    const planObj: any = {};
    if (planType === 1) {
      planObj.planTypeName = "Brand Deadline";
      planObj.planTypeIcon = <DeadlinePlan />;
      planObj.planDeadlineDate = `Due ${getUIFormatDate(brandDeadlineDate)}`;
    } else if (planType === 2) {
      planObj.planTypeName = "Initiative";
      planObj.planTypeIcon = <InitiativePlan />;
      planObj.planName = initiativeName;
    } else {
      planObj.planTypeName = "Opportunities";
      planObj.planTypeIcon = <RecommendedPlan />;
    }
    return planObj;
  };

  useEffect(() => {
    setPlanTypeDetail(getPlanTypeDetails(planType));
  }, [props]);

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {planType === brandDeadlinesType ? (
          <div className="plan-brand-deadline-wrapper">
            <div className="icon-name-wrapper">
              {planTypeDetail?.planTypeIcon}
              <Typography color={tokens.Text.General.Color} variant={"body2"} showBold>
                {planTypeDetail?.planTypeName}
              </Typography>
            </div>
            <div className="initiative-date">
              <Typography component={"div"} color={tokens.Text.General.Color} variant={"label"}>
                {planTypeDetail?.planDeadlineDate}
              </Typography>
            </div>
          </div>
        ) : (
          <div className="plan-initiative-wrapper">
            <div className="icon-name-wrapper">
              {planTypeDetail?.planTypeIcon}
              <Typography color={tokens.Text.General.Color} variant={"body2"} showBold>
                {planTypeDetail?.planTypeName}
              </Typography>
            </div>
            <div className="deadLine-date">
              <Typography
                component={"div"}
                color={tokens.Text.General.Color}
                variant={"label"}
                className="initiative-tag"
              >
                {planType !== brandDeadlinesType && planTypeDetail?.planDeadlineDate}
                {planTypeDetail?.planName}
              </Typography>
            </div>
          </div>
        )}
      </Box>
      <div className="initiative-tag-deskop">
        <Typography
          component={"div"}
          color={tokens.Text.General.Color}
          variant={"label"}
          sx={{
            marginTop: "8px"
          }}
        >
          {planType !== brandDeadlinesType && planTypeDetail?.planDeadlineDate}
          {planTypeDetail?.planName}
        </Typography>
      </div>
    </>
  );
}

export default PlanType;
